// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".task-name-input_wrapper__Eu1mE {\n  display: flex;\n  align-items: center;\n  padding-left: var(--spacing-07);\n}\n\n.task-name-input_input__chxQ1 {\n  resize: none;\n}\n", "",{"version":3,"sources":["webpack://./src/components/molecules/tasks/task-name-input/task-name-input.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  padding-left: var(--spacing-07);\n}\n\n.input {\n  resize: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "task-name-input_wrapper__Eu1mE",
	"input": "task-name-input_input__chxQ1"
};
export default ___CSS_LOADER_EXPORT___;
